import React, { createContext, useContext, useState, useMemo } from "react";
import PropTypes from "prop-types";
import contextActionType from "./context-action-type";

const { SET_STYLES_OPEN, GET_STYLES_OPEN, SET_ACTIVE_PLAYER, GET_ACTIVE_PLAYER } = contextActionType;

const ShortsContext = createContext();

export const useShortsContext = () => {
    return useContext(ShortsContext);
};

const ShortsContextProvider = ({ children }) => {
    const [stylesOpen, setStylesOpen] = useState(false);
    const [activePlayerId, setActivePlayerId] = useState(null);

    const setShortsContext = (stateKey, value) => {
        if (stateKey === SET_STYLES_OPEN) {
            setStylesOpen(value);
        } else if (stateKey === SET_ACTIVE_PLAYER) {
            setActivePlayerId(value);
        }
    };

    const getShortsContext = (stateKey) => {
        if (stateKey === GET_STYLES_OPEN) {
            return stylesOpen;
        } 
        if (stateKey === GET_ACTIVE_PLAYER) {
            return activePlayerId;
        }
        return null;
    };

    const contextValue = useMemo(() => ({
        setShortsContext,
        getShortsContext,
    }), [stylesOpen, activePlayerId]);

    return (
        <ShortsContext.Provider value={contextValue}>
            {children}
        </ShortsContext.Provider>
    );
};

ShortsContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ShortsContextProvider;